import React, { useState } from 'react'
import { Text } from '@components'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { CLEAR_ALL_FILTERS, CALL_CLEAR_FILTERS } from '@utils/constants'
import { FunnelPlotOutlined } from '@ant-design/icons'
import searchResultImage from '../../../../images/AdsPreview/searchResultImage.png'
import styles from './searchResultsError.module.css'

const SearchResultsError = () => {
  const dispatch = useDispatch()
  const handleClearFilters = () => {
    dispatch({ type: CLEAR_ALL_FILTERS, payload: false })
    setTimeout(() => {
      dispatch({ type: CALL_CLEAR_FILTERS, payload: true })
    }, 200)
    setTimeout(() => {
      dispatch({ type: CALL_CLEAR_FILTERS, payload: false })
    }, 400)
  }
  const channel = useSelector(state => state?.discoverAds?.channels)
  const advancedFilters = useSelector(state => state?.discoverAds?.advancedFilters)
  return (
    <>
      {advancedFilters?.adIndustry?.length > 0 ||
      advancedFilters?.descriptions?.length > 0 ||
      advancedFilters?.headlines?.length > 0 ||
      advancedFilters?.hooks?.length > 0 ||
      advancedFilters?.industry?.length > 0 ||
      advancedFilters?.landingPages?.length > 0 ||
      advancedFilters?.language?.length > 0 ||
      advancedFilters?.location?.length > 0 ||
      advancedFilters?.performance?.length > 0 ||
      advancedFilters?.platform?.length > 0 ? (
        <div style={{ justifyContent: 'center', marginTop: '150px' }}>
          <Text size={18} isBold style={{ textAlign: 'center' }}>
            Oops! We Couldn’t Find a Match
          </Text>
          <Text
            size={16}
            style={{
              marginTop: 16,
              color: '#67696B',
              width: '500px',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
            }}
          >
            Looks like there aren’t any matches for your selected filters. Try using fewer filters
            or adjusting your search to see more results.
          </Text>
          <div style={{ textAlign: 'center', marginTop: '15px', marginBottom: '30px' }}>
            <button className={styles.button} type="button" onClick={handleClearFilters}>
              <FunnelPlotOutlined style={{ fontSize: '16px' }} />
              Clear Filters
            </button>
          </div>
        </div>
      ) : (
        <div style={{ justifyContent: 'center' }}>
          <div style={{ marginTop: '104px', textAlign: 'center' }}>
            <img src={searchResultImage} alt="calender.png" />
          </div>
          <Text size={18} isBold style={{ textAlign: 'center', marginTop: '15px' }}>
            {
              // eslint-disable-next-line
              channel === 'Google'
                ? 'No Google results found.'
                : channel === 'Meta'
                ? 'No Meta results found.'
                : 'No results found.'
            }
          </Text>
          <Text
            size={16}
            style={{
              marginTop: 16,
              color: '#67696B',
              width: '292px',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
            }}
          >
            Try refining your search criteria or modify the filters.
          </Text>
        </div>
      )}
    </>
  )
}
export default SearchResultsError
